import React, { useRef, useMemo } from 'react';
import useGlossary from './../hooks/useGlossary';

const TextModule = ({ text, isLight, isActive = true }) => {
  const textRef = useRef();
  useGlossary(textRef, isLight, isActive);

  // {__html: text} is a new object on every render, so without memoizing it,
  // React sees a "changed" prop on every unrelated re-render (slider-ready,
  // window resize, animation completion, etc.) and rewrites the DOM - wiping
  // out the glossary-wrapper/tippy setup useGlossary already attached.
  const htmlProp = useMemo(() => ({ __html: text }), [text]);

  if (!text) {
    return null;
  }

  return (
    <div ref={textRef} dangerouslySetInnerHTML={htmlProp} />
  );
};

export default TextModule;
